import { storage } from './localStorage';

function getUserToken() {
  return storage.get('userAuthToken');
}

function setUserToken(userToken) {
  return storage.set('userAuthToken', userToken);
}

export const auth = {
  getUserToken: getUserToken,
  setUserToken: setUserToken,
};



// WEBPACK FOOTER //
// ./src/libs/auth.js